import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';

const withAuth = component => {
  if (process.env.NEXT_PUBLIC_ASSEMBLY === 'true') {
    return withAuthenticationRequired(component, { onRedirecting: () => <div>Redirecting you to the login page...</div> });
  }
  return component;
};

export default withAuth;
